/**
 * @generated SignedSource<<cc5b8beefef28a5276a73e037705928c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskHintFeedbackPublishInput = {
  task: string;
};
export type TaskHintFeedbackPublishDialog_taskHintFeedbackPublishMutation$variables = {
  input: TaskHintFeedbackPublishInput;
};
export type TaskHintFeedbackPublishDialog_taskHintFeedbackPublishMutation$data = {
  readonly taskHintFeedbackPublish: {
    readonly hint: {
      readonly id: string;
      readonly publishedText: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"TaskHintStatusLabel_taskHint">;
    } | null;
    readonly id: string;
    readonly submitFeedback: {
      readonly id: string;
      readonly publishedGeneral: string | null;
      readonly publishedSpecial: string | null;
      readonly publishedSpecialAnswer: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"TaskSubmitFeedbackStatusLabel_taskSubmitFeedback">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"TaskActionsMutationButtonStack_task" | "TaskTaskHistoryPaginator_task">;
  };
};
export type TaskHintFeedbackPublishDialog_taskHintFeedbackPublishMutation = {
  response: TaskHintFeedbackPublishDialog_taskHintFeedbackPublishMutation$data;
  variables: TaskHintFeedbackPublishDialog_taskHintFeedbackPublishMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedText",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedGeneral",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedSpecial",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedSpecialAnswer",
  "storageKey": null
},
v7 = [
  (v2/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "order",
    "value": {
      "order": "DESC"
    }
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v11 = [
  (v2/*: any*/),
  (v10/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "difficulty",
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "order",
    "value": {
      "created": "DESC"
    }
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "before",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "after",
  "storageKey": null
},
v17 = [
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Diff",
  "kind": "LinkedField",
  "name": "problem",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Diff",
  "kind": "LinkedField",
  "name": "solution",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v20 = [
  (v18/*: any*/),
  (v19/*: any*/)
],
v21 = [
  (v15/*: any*/),
  (v16/*: any*/),
  (v14/*: any*/)
],
v22 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "difficulty",
    "plural": false,
    "selections": (v21/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "unitDs",
    "plural": true,
    "selections": (v21/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "problem",
    "plural": false,
    "selections": (v21/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "solution",
    "plural": false,
    "selections": (v21/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "answer",
    "plural": false,
    "selections": (v21/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "answerChoiceCount",
    "plural": false,
    "selections": (v21/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "answerType",
    "plural": false,
    "selections": (v21/*: any*/),
    "storageKey": null
  }
],
v23 = [
  (v15/*: any*/),
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskHintFeedbackPublishDialog_taskHintFeedbackPublishMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "taskHintFeedbackPublish",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TaskActionsMutationButtonStack_task"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TaskTaskHistoryPaginator_task"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskHint",
            "kind": "LinkedField",
            "name": "hint",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TaskHintStatusLabel_taskHint"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskSubmitFeedback",
            "kind": "LinkedField",
            "name": "submitFeedback",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TaskSubmitFeedbackStatusLabel_taskSubmitFeedback"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskHintFeedbackPublishDialog_taskHintFeedbackPublishMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "taskHintFeedbackPublish",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "assignedTo",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskHint",
            "kind": "LinkedField",
            "name": "hint",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              },
              (v3/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskSubmitFeedback",
            "kind": "LinkedField",
            "name": "submitFeedback",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "specialAnswer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "special",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "general",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Course",
            "kind": "LinkedField",
            "name": "course",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "year",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "UnitD",
            "kind": "LinkedField",
            "name": "publishedUnitDs",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnitD",
                "kind": "LinkedField",
                "name": "nextUnitD",
                "plural": false,
                "selections": (v11/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnitD",
                "kind": "LinkedField",
                "name": "previousUnitD",
                "plural": false,
                "selections": (v11/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": "publishedUnitDs(order:{\"order\":\"DESC\"})"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMigrated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "migrationPair",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sequence",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskProblem",
            "kind": "LinkedField",
            "name": "problem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "problem",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "solution",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "creationType",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "aiFile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "size",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "objectUrl",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskLabeling",
            "kind": "LinkedField",
            "name": "finalLabeling",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": (v9/*: any*/),
                "concreteType": "UnitD",
                "kind": "LinkedField",
                "name": "unitDs",
                "plural": true,
                "selections": (v7/*: any*/),
                "storageKey": "unitDs(order:{\"order\":\"DESC\"})"
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inMigrationPairSync",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "TaskHistoryConnection",
            "kind": "LinkedField",
            "name": "histories",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskHistoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskHistory",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "picture",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isDeleted",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "difference",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isDifference"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v20/*: any*/),
                            "type": "TaskProblemTypingDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "answerType",
                                "plural": false,
                                "selections": (v17/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "answer",
                                "plural": false,
                                "selections": (v17/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "answerChoiceCount",
                                "plural": false,
                                "selections": (v17/*: any*/),
                                "storageKey": null
                              },
                              (v18/*: any*/),
                              (v19/*: any*/)
                            ],
                            "type": "TaskProblemCreationDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v20/*: any*/),
                            "type": "TaskImageCreationDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "TaskFirstLabelingDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "TaskSecondLabelingDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "TaskPublishDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "description",
                                "plural": false,
                                "selections": (v23/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "teacherName",
                                "plural": false,
                                "selections": (v23/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "title",
                                "plural": false,
                                "selections": (v23/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "type",
                                "plural": false,
                                "selections": (v23/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "TaskVideoDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "isPremium",
                                "plural": false,
                                "selections": (v23/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "isRecommended",
                                "plural": false,
                                "selections": (v23/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "taskVideoTitle",
                                "plural": false,
                                "selections": (v23/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "thumbnailHorizontalUrl",
                                "plural": false,
                                "selections": (v23/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "thumbnailVerticalUrl",
                                "plural": false,
                                "selections": (v23/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "TaskSolutionVideoDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "hint",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "specialAnswer",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "special",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "general",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "incorrect",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "correct",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "TaskHintFeedbackDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "title",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "description",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "originalTask",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "creationType",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "assignedTo",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "TaskDifference",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "histories(first:10,order:{\"created\":\"DESC\"})"
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "filters": [
              "filters",
              "order"
            ],
            "handle": "connection",
            "key": "TaskTaskHistoryPaginator_task_histories",
            "kind": "LinkedHandle",
            "name": "histories"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e3fe61acab688de964752e875607f1bb",
    "id": null,
    "metadata": {},
    "name": "TaskHintFeedbackPublishDialog_taskHintFeedbackPublishMutation",
    "operationKind": "mutation",
    "text": "mutation TaskHintFeedbackPublishDialog_taskHintFeedbackPublishMutation(\n  $input: TaskHintFeedbackPublishInput!\n) {\n  taskHintFeedbackPublish(input: $input) {\n    id\n    ...TaskActionsMutationButtonStack_task\n    ...TaskTaskHistoryPaginator_task\n    hint {\n      id\n      publishedText\n      ...TaskHintStatusLabel_taskHint\n    }\n    submitFeedback {\n      id\n      publishedGeneral\n      publishedSpecial\n      publishedSpecialAnswer\n      ...TaskSubmitFeedbackStatusLabel_taskSubmitFeedback\n    }\n  }\n}\n\nfragment DiffItem_diff on Diff {\n  before\n  after\n}\n\nfragment TaskActionsMutationButtonStack_task on Task {\n  id\n  actions\n  assignedTo {\n    id\n  }\n  ...TaskHintFeedbackPublishDialog_task\n  ...TaskMigrateDialog_task\n  ...TaskMigrationPairSyncDialog_task\n  difficulty\n  publishedUnitDs(order: {order: DESC}) {\n    id\n  }\n  finalLabeling {\n    difficulty\n    unitDs(order: {order: DESC}) {\n      id\n    }\n    id\n  }\n  inMigrationPairSync\n  problem {\n    id\n    problem\n    solution\n  }\n}\n\nfragment TaskDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskDifference {\n    title {\n      __typename\n    }\n    description {\n      __typename\n    }\n    status {\n      __typename\n    }\n    originalTask {\n      __typename\n    }\n    creationType {\n      __typename\n    }\n    assignedTo {\n      __typename\n    }\n  }\n}\n\nfragment TaskDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskDifference {\n    title {\n      ...DiffItem_diff\n    }\n    description {\n      ...DiffItem_diff\n    }\n    status {\n      ...DiffItem_diff\n    }\n    originalTask {\n      ...DiffItem_diff\n    }\n    creationType {\n      ...DiffItem_diff\n    }\n    assignedTo {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskFirstLabelingDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskFirstLabelingDifference {\n    difficulty {\n      __typename\n    }\n    unitDs {\n      __typename\n    }\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n    answer {\n      __typename\n    }\n    answerChoiceCount {\n      __typename\n    }\n    answerType {\n      __typename\n    }\n  }\n}\n\nfragment TaskFirstLabelingDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskFirstLabelingDifference {\n    difficulty {\n      ...DiffItem_diff\n    }\n    unitDs {\n      ...DiffItem_diff\n    }\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n    answer {\n      ...DiffItem_diff\n    }\n    answerChoiceCount {\n      ...DiffItem_diff\n    }\n    answerType {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskHintFeedbackDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskHintFeedbackDifference {\n    hint {\n      __typename\n    }\n    specialAnswer {\n      __typename\n    }\n    special {\n      __typename\n    }\n    general {\n      __typename\n    }\n    incorrect {\n      __typename\n    }\n    correct {\n      __typename\n    }\n  }\n}\n\nfragment TaskHintFeedbackDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskHintFeedbackDifference {\n    hint {\n      ...DiffItem_diff\n    }\n    specialAnswer {\n      ...DiffItem_diff\n    }\n    special {\n      ...DiffItem_diff\n    }\n    general {\n      ...DiffItem_diff\n    }\n    incorrect {\n      ...DiffItem_diff\n    }\n    correct {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskHintFeedbackPublishDialog_task on Task {\n  id\n  hint {\n    id\n    text\n  }\n  submitFeedback {\n    id\n    specialAnswer\n    special\n    general\n  }\n}\n\nfragment TaskHintStatusLabel_taskHint on TaskHint {\n  status\n}\n\nfragment TaskHistoryDialog_taskHistory on TaskHistory {\n  createdBy {\n    name\n    picture\n    id\n  }\n  created\n  difference {\n    __typename\n    ...TaskProblemTypingDifferenceCounterLabel_difference\n    ...TaskProblemTypingDifferenceItemList_difference\n    ...TaskProblemCreationDifferenceCounterLabel_difference\n    ...TaskProblemCreationDifferenceItemList_difference\n    ...TaskImageCreationDifferenceCounterLabel_difference\n    ...TaskImageCreationDifferenceItemList_difference\n    ...TaskFirstLabelingDifferenceItemList_difference\n    ...TaskFirstLabelingDifferenceCounterLabel_difference\n    ...TaskSecondLabelingDifferenceItemList_difference\n    ...TaskSecondLabelingDifferenceCounterLabel_difference\n    ...TaskPublishDifferenceItemList_difference\n    ...TaskPublishDifferenceCounterLabel_difference\n    ...TaskVideoDifferenceCounterLabel_difference\n    ...TaskVideoDifferenceItemList_difference\n    ...TaskSolutionVideoDifferenceCounterLabel_difference\n    ...TaskSolutionVideoDifferenceItemList_difference\n    ...TaskHintFeedbackDifferenceItemList_difference\n    ...TaskHintFeedbackDifferenceCounterLabel_difference\n    ...TaskDifferenceItemList_difference\n    ...TaskDifferenceCounterLabel_difference\n  }\n}\n\nfragment TaskHistoryTimelineItem_taskHistory on TaskHistory {\n  created\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  type\n}\n\nfragment TaskImageCreationDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskImageCreationDifference {\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n  }\n}\n\nfragment TaskImageCreationDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskImageCreationDifference {\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskMigrateDialog_task on Task {\n  id\n  course {\n    id\n    year\n  }\n  publishedUnitDs(order: {order: DESC}) {\n    id\n    description\n    nextUnitD {\n      id\n      description\n    }\n    previousUnitD {\n      id\n      description\n    }\n  }\n}\n\nfragment TaskMigrationPairSyncDialog_task on Task {\n  id\n  isMigrated\n  migrationPair {\n    id\n    sequence\n  }\n  problem {\n    problem\n    solution\n    creationType\n    id\n  }\n  aiFile {\n    key\n    size\n    objectUrl\n    id\n  }\n}\n\nfragment TaskProblemCreationDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskProblemCreationDifference {\n    answerType {\n      __typename\n    }\n    answer {\n      __typename\n    }\n    answerChoiceCount {\n      __typename\n    }\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n  }\n}\n\nfragment TaskProblemCreationDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskProblemCreationDifference {\n    answer {\n      ...DiffItem_diff\n    }\n    answerChoiceCount {\n      ...DiffItem_diff\n    }\n    answerType {\n      ...DiffItem_diff\n    }\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskProblemTypingDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskProblemTypingDifference {\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n  }\n}\n\nfragment TaskProblemTypingDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskProblemTypingDifference {\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskPublishDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskPublishDifference {\n    difficulty {\n      __typename\n    }\n    unitDs {\n      __typename\n    }\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n    answer {\n      __typename\n    }\n    answerChoiceCount {\n      __typename\n    }\n    answerType {\n      __typename\n    }\n  }\n}\n\nfragment TaskPublishDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskPublishDifference {\n    difficulty {\n      ...DiffItem_diff\n    }\n    unitDs {\n      ...DiffItem_diff\n    }\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n    answer {\n      ...DiffItem_diff\n    }\n    answerChoiceCount {\n      ...DiffItem_diff\n    }\n    answerType {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskSecondLabelingDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskSecondLabelingDifference {\n    difficulty {\n      __typename\n    }\n    unitDs {\n      __typename\n    }\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n    answer {\n      __typename\n    }\n    answerChoiceCount {\n      __typename\n    }\n    answerType {\n      __typename\n    }\n  }\n}\n\nfragment TaskSecondLabelingDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskSecondLabelingDifference {\n    difficulty {\n      ...DiffItem_diff\n    }\n    unitDs {\n      ...DiffItem_diff\n    }\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n    answer {\n      ...DiffItem_diff\n    }\n    answerChoiceCount {\n      ...DiffItem_diff\n    }\n    answerType {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskSolutionVideoDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskSolutionVideoDifference {\n    isPremium {\n      before\n      after\n    }\n    isRecommended {\n      before\n      after\n    }\n    taskVideoTitle {\n      before\n      after\n    }\n    thumbnailHorizontalUrl {\n      before\n      after\n    }\n    thumbnailVerticalUrl {\n      before\n      after\n    }\n  }\n}\n\nfragment TaskSolutionVideoDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskSolutionVideoDifference {\n    taskVideoTitle {\n      ...DiffItem_diff\n    }\n    isPremium {\n      ...DiffItem_diff\n    }\n    thumbnailHorizontalUrl {\n      ...DiffItem_diff\n    }\n    thumbnailVerticalUrl {\n      ...DiffItem_diff\n    }\n    isRecommended {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskSubmitFeedbackStatusLabel_taskSubmitFeedback on TaskSubmitFeedback {\n  status\n}\n\nfragment TaskTaskHistoryPaginator_task on Task {\n  histories(order: {created: DESC}, first: 10) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        type\n        ...TaskHistoryDialog_taskHistory\n        ...TaskHistoryTimelineItem_taskHistory\n        __typename\n      }\n    }\n  }\n  id\n}\n\nfragment TaskVideoDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskVideoDifference {\n    description {\n      before\n      after\n    }\n    teacherName {\n      before\n      after\n    }\n    title {\n      before\n      after\n    }\n    type {\n      before\n      after\n    }\n  }\n}\n\nfragment TaskVideoDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskVideoDifference {\n    title {\n      ...DiffItem_diff\n    }\n    description {\n      ...DiffItem_diff\n    }\n    teacherName {\n      ...DiffItem_diff\n    }\n    type {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "00de8aaddf1719801ea87b1ecacdb5d2";

export default node;
